<template>  
  <router-view></router-view>
</template>

<script>
   export default {
    name: 'BudgetsIndex',
    data: function () {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
